module.exports = __webpack_public_path__ + "img/premiering_background@2x.9c17b557.png";